import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { TargetReviewCommentsQuery } from '~/apollo/generated/v3/graphql';
import { Role } from '~/apollo/generated/v3/graphql';
import { LocalDate } from '~/components/common/LocalDate';
import { Tooltip } from '~/components/common/Tooltip';
import { DeleteReviewComment } from '~/components/review-comment/delete-review-comment';
import { Button } from '~/components/ui/button';
import { useAuthenticated } from '~/contexts/auth';
import type { RefetchQueries } from '~/utils/graphql';

export function ReviewCommentDisplay({
  reviewComment,
  refetchQueries,
}: {
  reviewComment: TargetReviewCommentsQuery['reviewCommentList'][number];
  refetchQueries: RefetchQueries;
}) {
  const { authority } = useAuthenticated();
  const isAuthor = authority.user.id === reviewComment.authorId;
  const canDelete = isAuthor || authority.roles.includes(Role.RoleAdmin);

  return (
    <div className="bg-slate-100">
      <div className="flex justify-between gap-2 items-start bg-slate-200 p-2">
        <div className="text-sm">
          <strong>{reviewComment.author.name}</strong>
          <br />
          <span className="text-muted text-xs">
            <LocalDate
              date={reviewComment.insertedAt}
              format={{
                dateStyle: 'medium',
                timeStyle: 'short',
              }}
            />
          </span>
        </div>

        {canDelete && (
          <div className="float-right">
            <DeleteReviewComment
              commentId={reviewComment.id}
              refetchQueries={refetchQueries}
            >
              {(confirmDelete, loading) => (
                <Tooltip message="Delete comment">
                  <Button
                    type="button"
                    color="ghost"
                    size="xs"
                    onClick={confirmDelete}
                    disabled={loading}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </Tooltip>
              )}
            </DeleteReviewComment>
          </div>
        )}
      </div>
      <div className="p-4 break-words whitespace-pre-line">
        {reviewComment.comment}
      </div>
    </div>
  );
}
